<template>
  <div id="por-indicador">
    <div
      v-if="loadingPage || loadingData"
      class="d-flex justify-content-center align-items-center"
      style="height: 50vh"
    >
      <b-spinner large variant="primary"></b-spinner>
    </div>

    <div v-else>
      <div class="row mt-3 align-items-center">
        <div class="col-12 col-md-6 col-lg-3 mb-2 mb-lg-0">
          <vue-select
            name="periodo"
            v-model="periodo"
            class="select-periodo"
            :clearable="false"
            :options="optionsPeriodo"
            label="label"
            placeholder="Período"
            @input="onChangePeriodo"
          >
            <template slot="option" slot-scope="option">
              {{ option.label }}
            </template>
            <div slot="no-options">Não há opções correspondentes</div>
          </vue-select>
        </div>
        <div class="col-12 col-md-6 col-lg-6 mb-2 mb-lg-0">
          <vue-select
            id="select-tipo-equipe"
            name="tipo-equipe"
            v-model="selectedIndicador"
            class="select-tipo-equipe"
            :clearable="false"
            :options="optionsIndicadores"
            label="ds_indicador"
            placeholder="Todas"
            :disabled="disabledSelectIndicadores"
            @input="onChangeIndicador"
          >
            <template slot="option" slot-scope="option">
              {{ option.ds_indicador }}
            </template>
            <div slot="no-options">Não há opções correspondentes</div>
          </vue-select>
        </div>
        <div
          class="col-12 col-lg-3 mb-2 mb-lg-0 d-flex align-items-center justify-content-lg-end"
        >
          <!-- Botão SQL -->
          <button
            v-if="
              $store.state.id_funcao == 2 && $store.state.cod_ibge != 1111111
            "
            class="btn mr-2"
            @click="showSql = true"
            style="text-transform: initial"
          >
            SQL
          </button>

          <download-files
            :callback-pdf="generatePdf"
            :data="dadosExportacao"
            :fields="dataFieldsPorIndicador"
            name="resultado-municipal-por-indicador"
          >
          </download-files>
        </div>
      </div>
      <dashboard-por-indicador
        :dadosDashboard="dadosPorIndicador"
        :periodo="periodo"
        :selectedIndicador="selectedIndicador"
      ></dashboard-por-indicador>
    </div>

    <SqlModal
      :show.sync="showSql"
      :activeKey="activeKey"
      :resultado-indicadores-qualidade="resultadoIndicadoresQualidade"
      :can-download="true"
    />
  </div>
</template>

<script>
import DashboardPorIndicador from './components/DashboardPorIndicador'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import { dataFieldsPorIndicador } from './utils.js'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import SqlModal from '@/pages/GestaoCadastros/CidadaoPainel/components/SqlModal.vue'

export default {
  props: {
    loadingPage: {
      type: Boolean,
      default: false,
    },
    cadastros: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    DashboardPorIndicador,
    DownloadFiles,
    SqlModal,
  },
  mixins: [utils],
  data() {
    return {
      dadosPorIndicadorOriginais: [],
      dadosPorIndicador: [],
      periodo: null,
      optionsPeriodo: [],
      loadingData: false,
      optionsIndicadores: [],
      selectedIndicador: {
        indicador: 56,
        ds_indicador: 'Vínculo e acompanhamento por parâmetro de cadastro',
      },
      disabledSelectIndicadores: true,
      indicadores: [],
      dataFieldsPorIndicador: {
        ...dataFieldsPorIndicador,
      },
      showSql: false,
      activeKey: '',
    }
  },
  computed: {
    resultadoIndicadoresQualidade() {
      return {
        indicador: this.selectedIndicador?.indicador ?? null,
        mes_ano: this.periodo?.value ?? null,
      }
    },

    dadosExportacao() {
      const mesAno = this.formatarMesAnoExportacao(this.periodo?.value)
      const dsIndicador = this.selectedIndicador?.ds_indicador || ''
      const indicador = Number(this.selectedIndicador?.indicador)

      return this.dadosPorIndicador.flatMap((grupo) => {
        return this.parseEquipes(grupo.equipes).map((equipe) => ({
          mes_ano: mesAno,
          ds_indicador: equipe.ds_indicador || dsIndicador,
          ine: equipe.ine ?? '',
          nm_efb: indicador === 47 ? '-' : equipe.numerador ?? '-',
          dn_efb: equipe.denominador ?? '-',
          peso: equipe.peso ?? '-',
          nota: equipe.nota ?? '-',
          efb_resultado: equipe.resultado ?? '-',
          efb_classificacao: [54, 55, 56].includes(indicador)
            ? equipe.classificacao_param ??
              equipe.classificacao ??
              grupo.classificacao ??
              '-'
            : equipe.classificacao ?? grupo.classificacao ?? '-',
        }))
      })
    },
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
        const periodos = Array.from(
          new Map(
            this.cadastros
              .filter((item) => item.mes_ano) // garante válido
              .map((item) => [
                item.mes_ano, // chave única
                {
                  mes_ano: item.mes_ano,
                  mes_ano_quad: item.mes_ano_quad,
                },
              ])
          ).values()
        )
        // ordenação desc
        periodos.sort((a, b) => {
          const [mesA, anoA] = a.mes_ano.split('/').map(Number)
          const [mesB, anoB] = b.mes_ano.split('/').map(Number)

          if (anoA !== anoB) return anoB - anoA
          return mesB - mesA
        })

        // monta options do select
        this.optionsPeriodo = periodos.map((p) => {
          const mes = Number(p.mes_ano.split('/')[0])
          const isQuad = [4, 8, 12].includes(mes)

          return {
            value: p.mes_ano,
            label: isQuad && p.mes_ano_quad ? p.mes_ano_quad : p.mes_ano,
          }
        })
        this.periodo = this.optionsPeriodo[0]
        this.onChangePeriodo(this.periodo)
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  methods: {
    async onChangePeriodo(item) {
      let periodo = item.value.replace('/', '-')
      try {
        this.loadingData = true
        this.disabledSelectIndicadores = true
        // indicadores
        let response = await this.$api.get(
          `/app/indicadores-aps/resultado-municipal/${this.$store.state.cod_ibge}/indicadores/${periodo}`
        )
        if (response) {
          this.optionsIndicadores = response.data
        }
        // dados por indicador
        let response2 = await this.$api.get(
          `/app/indicadores-aps/resultado-municipal/${this.$store.state.cod_ibge}/indicadores/${periodo}/dados`
        )
        if (response2) {
          this.dadosPorIndicadorOriginais = response2.data
          this.dadosPorIndicador = response2.data
          this.onChangeIndicador(this.selectedIndicador)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingData = false
        this.disabledSelectIndicadores = false
      }
    },

    onChangeIndicador(item) {
      if (!item) {
        this.dadosPorIndicador = this.dadosPorIndicadorOriginais
        return
      }
      this.dadosPorIndicador = this.dadosPorIndicadorOriginais.filter((el) => {
        return el.indicador == item.indicador
      })

      const indicadorKey = {
        46: 'mais-acesso',
        47: 'saude-da-mulher',
        48: 'pessoa-diabetica',
        49: 'pessoa-idosa',
        50: 'pessoa-hipertensa',
        51: 'desenvolvimento-infantil',
        52: 'gestantes-puerperas',
      }

      this.activeKey = indicadorKey[item.indicador] || ''
    },

    /**
     * Converte o JSON de equipes do agrupamento em array.
     *
     * @param {String|Array} equipes Equipes retornadas pela API.
     * @returns {Array} Lista de equipes.
     */
    parseEquipes(equipes) {
      if (Array.isArray(equipes)) {
        return equipes
      }

      try {
        const parsed = JSON.parse(equipes || '[]')
        return Array.isArray(parsed) ? parsed : []
      } catch {
        return []
      }
    },

    /**
     * Formata o período no padrão da exportação, por exemplo 5/2026 -> mai-26.
     *
     * @param {String} mesAno Período no formato MM/YYYY.
     * @returns {String} Período abreviado.
     */
    formatarMesAnoExportacao(mesAno) {
      if (!mesAno) {
        return ''
      }

      const [mes, ano] = String(mesAno).split('/')
      const meses = {
        1: 'jan',
        2: 'fev',
        3: 'mar',
        4: 'abr',
        5: 'mai',
        6: 'jun',
        7: 'jul',
        8: 'ago',
        9: 'set',
        10: 'out',
        11: 'nov',
        12: 'dez',
      }

      const abreviacao = meses[Number(mes)] || mes
      const anoCurto = String(ano || '').slice(-2)

      return `${abreviacao}-${anoCurto}`
    },

    /**
     * Gera o PDF com as equipes do indicador selecionado.
     */
    generatePdf() {
      const title_pdf = 'Resultado Municipal - Por indicador'
      const titlePdfSave = this.titlePdf('Resultado Municipal - Por indicador')
      const description_pdf = 'Classificação por equipe nos Indicadores APS.'
      const headers_pdf = [
        'mes_ano',
        'ds_indicador',
        'ine',
        'nm_efb',
        'dn_efb',
        'peso',
        'nota',
        'efb_resultado',
        'efb_classificacao',
      ]

      const doc = new jsPDF({
        orientation: 'landscape',
        ...this.encryptionPdf(),
      })

      this.fileToBase64(this.$store.state.infoMunicipio.brasao)
        .then((base64data) => {
          let verticalPosition = this.headerPdf(
            doc,
            base64data,
            title_pdf,
            description_pdf
          )

          verticalPosition = this.bodyPdf(
            doc,
            [
              { label: 'Período', value: this.periodo?.label || '' },
              {
                label: 'Indicador',
                value: this.selectedIndicador?.ds_indicador || '',
              },
            ],
            verticalPosition
          )

          const bodyRows = this.dadosExportacao.map((item) => [
            item.mes_ano,
            item.ds_indicador,
            item.ine,
            item.nm_efb,
            item.dn_efb,
            item.peso,
            item.nota,
            item.efb_resultado,
            item.efb_classificacao,
          ])

          doc.autoTable({
            head: [headers_pdf],
            body: bodyRows,
            startY: verticalPosition,
            theme: 'striped',
            headStyles: {
              fillColor: '#ccc',
              fontSize: 8,
              textColor: '#000',
              halign: 'center',
            },
            bodyStyles: {
              fontSize: 8,
              halign: 'center',
            },
            styles: { cellPadding: 2 },
          })

          this.footerPdfCentralizado(doc, doc.autoTable.previous.finalY, 'l')
          doc.save(titlePdfSave + '.pdf')

          this.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
            position: 'topRight',
          })
        })
        .catch((error) => {
          console.error(error)
          this.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
            position: 'topRight',
          })
        })
    },
  },
}
</script>

<style lang="scss">
#por-indicador {
}
</style>
